import { render, staticRenderFns } from "./AboutUsPg.vue?vue&type=template&id=08d2f1a4&scoped=true&"
import script from "./AboutUsPg.vue?vue&type=script&lang=js&"
export * from "./AboutUsPg.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPg.vue?vue&type=style&index=0&id=08d2f1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2f1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
